<template>
  <div style="margin-bottom: 20px">
    <el-radio-group v-model="infoLocal.card_type" @change="valueChanged">
      <el-radio-button label="top_level">Для директоров 20+</el-radio-button>
      <el-radio-button label="card">Карта целей</el-radio-button>
      <el-radio-button label="abcd">ABCD</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "cards-create-info",
  components: {},
  props: {
    info: {type: Object, required:true},
    card: {type: Object},
  },
  computed: {},
  watch: {
    'info': function(newVal){
      this.infoLocal = newVal;
    },
  },
  data() {
    return {
      infoLocal: {
        card_type: null,
      },
    }
  },
  methods: {
    valueChanged(){
      this.$emit('update:info', this.infoLocal);
    }
  }
}
</script>

<style lang="scss">

</style>